"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _changeView = require("./changeView");
Object.keys(_changeView).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _changeView[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _changeView[key];
    }
  });
});
var _previousView = require("./previousView");
Object.keys(_previousView).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _previousView[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _previousView[key];
    }
  });
});